import React from "react";
import { Badge, colors } from "../design/badge";
import { ParticipantRole } from "../models/ParticipantRole";

interface Props {
  role?: ParticipantRole;
}

const ParticipantRoleBadge: React.FC<Props> = ({ role }) => {
  if (!role) return null;
  let color;
  let title;
  switch (role) {
    case "plaintiff":
      color = "red";
      title = "Plaintiff";
      break;
    case "defendant":
      color = "blue";
      title = "Defendant";
      break;
    case "petitioner":
      color = "green";
      title = "Petitioner";
      break;
    case "respondent":
      color = "yellow";
      title = "Respondent";
      break;
    case "dependent":
      color = "purple";
      title = "Dependent";
      break;
    case "minor_child":
      color = "orange";
      title = "Minor Child";
      break;
    case "witness":
      color = "teal";
      title = "Witness";
      break;
    case "intervenor":
      color = "pink";
      title = "Intervenor";
      break;
    default:
      color = "grey"; // Default color if status is unknown
      title = role ?? "Unknown";
      break;
  }
  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default ParticipantRoleBadge;
